export const generateAssetUrl = (path: string):string => path
